import React from 'react'
import Pagination from '@mui/material/Pagination'

const AdxPagination = ({ sx, ...rest }) => {
  return (
    <Pagination
      {...rest}
      shape="rounded"
      sx={{
        '& .MuiPaginationItem-root': {
          color: 'light-gray-text.main',
          '&.Mui-selected': {
            backgroundColor: 'alternate.main',
            color: 'white.main',
            '&:hover': {
              backgroundColor: 'alternate.main',
              color: 'white.main',
            },
          },
          '&:hover': {
            backgroundColor: 'gray-background.main',
          },
        },
        ...sx,
      }}
    />
  )
}

export default AdxPagination
